import { createStore } from '@aibees/shared/store';
import { PeopleDrawerStoreData as StoreData } from './types';

const usePeopleDrawerStore = createStore<StoreData>('people-drawer', (set) => ({
  defaultActiveTab: undefined,
  setDefaultActiveTab: (defaultActiveTab) => set({ defaultActiveTab }),
}));

export default usePeopleDrawerStore;
